import {combineReducers} from 'redux';

import {SelectionSliceFor} from '../../../store/SelectionSliceFor';

const entityKey = 'testing-test-definitions';

const selectionSlice = SelectionSliceFor(entityKey);

export const {
    addToSelection,
    removeFromSelection,
    clearSelection,
} = selectionSlice.actions;

export const TestDefinitionsReducer = combineReducers({
    selection: selectionSlice.reducer,
});
